<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import Auth from "@/plugins/services/auth";
export default {
  name: "App",
};
</script>
